import { useEffect, useRef } from "react";
import { QrCode, Download, Printer } from "lucide-react";
import { QRCodeCanvas } from "qrcode.react";
import { useLang } from "@/context/LanguageContext";
import { GOOGLE_REVIEW_URL } from "@/lib/contact";

const W = 1080;
const H = 1527;

const star = (ctx, cx, cy, r, fill) => {
  ctx.beginPath();
  for (let i = 0; i < 10; i++) {
    const ang = -Math.PI / 2 + (i * Math.PI) / 5;
    const rr = i % 2 === 0 ? r : r * 0.42;
    const x = cx + rr * Math.cos(ang);
    const y = cy + rr * Math.sin(ang);
    i === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
  }
  ctx.closePath();
  ctx.fillStyle = fill;
  ctx.fill();
};

export const ReviewQRCard = () => {
  const { t } = useLang();
  const q = t.dash.qrCard;
  const canvasRef = useRef(null);
  const qrRef = useRef(null);
  const url = GOOGLE_REVIEW_URL || `${window.location.origin}/avis`;

  useEffect(() => {
    const ctx = canvasRef.current.getContext("2d");
    ctx.fillStyle = "#0a0a0a";
    ctx.fillRect(0, 0, W, H);
    const g = ctx.createRadialGradient(W / 2, 500, 50, W / 2, 500, 1100);
    g.addColorStop(0, "rgba(255,121,0,0.22)");
    g.addColorStop(1, "rgba(255,121,0,0)");
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, W, H);
    ctx.textAlign = "center";
    ctx.fillStyle = "#ffffff";
    ctx.font = "700 76px Arial";
    ctx.fillText("Votre avis compte", W / 2, 170);
    for (let i = 0; i < 5; i++) star(ctx, W / 2 + (i - 2) * 92, 280, 34, "#FBBC04");
    const qrCanvas = qrRef.current?.querySelector("canvas");
    const qs = 560;
    const qx = (W - qs) / 2;
    const qy = 400;
    ctx.fillStyle = "#ffffff";
    ctx.beginPath();
    ctx.roundRect(qx - 36, qy - 36, qs + 72, qs + 72, 28);
    ctx.fill();
    if (qrCanvas) ctx.drawImage(qrCanvas, qx, qy, qs, qs);
    ctx.fillStyle = "#ffffff";
    ctx.font = "600 44px Arial";
    ctx.fillText("Scannez pour laisser votre avis", W / 2, qy + qs + 140);
    ctx.fillStyle = "rgba(255,255,255,0.5)";
    ctx.font = "400 34px Arial";
    ctx.fillText("Merci pour votre confiance !", W / 2, qy + qs + 200);
    ctx.fillStyle = "#FF7900";
    ctx.font = "700 46px Arial";
    ctx.fillText("Sam — Smart Telecom Advisor", W / 2, H - 220);
    ctx.font = "700 42px Arial";
    ctx.fillText("+32 473 22 33 44", W / 2, H - 150);
    ctx.fillStyle = "rgba(255,255,255,0.6)";
    ctx.font = "400 36px Arial";
    ctx.fillText("www.smartelecomadvisor.be", W / 2, H - 85);
  }, []);

  const download = () => {
    const a = document.createElement("a");
    a.href = canvasRef.current.toDataURL("image/png");
    a.download = "carte-avis-qr.png";
    a.click();
  };

  const print = () => {
    const dataUrl = canvasRef.current.toDataURL("image/png");
    const w = window.open("", "_blank");
    if (!w) return;
    w.document.write(`<html><head><title>Carte avis</title><style>body{margin:0;display:flex;justify-content:center}img{width:105mm;height:148mm}</style></head><body><img src="${dataUrl}" onload="window.print()"/></body></html>`);
    w.document.close();
  };

  return (
    <div className="bg-[#111111] border border-white/10 p-6 md:p-8 mb-10" data-testid="review-qr-card-panel">
      <p className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-white/40 mb-2">
        <QrCode className="w-4 h-4 text-[#FBBC04]" /> {q.title}
      </p>
      <p className="text-xs text-white/40 mb-5">{q.hint}</p>
      <div className="flex flex-col md:flex-row gap-6 items-start">
        <div className="flex-1 flex flex-wrap gap-3">
          <button
            onClick={download}
            data-testid="qr-card-download"
            className="inline-flex items-center gap-2 bg-[#FF7900] hover:bg-white hover:text-black text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-colors duration-300"
          >
            <Download className="w-4 h-4" /> {q.download}
          </button>
          <button
            onClick={print}
            data-testid="qr-card-print"
            className="inline-flex items-center gap-2 border border-white/20 hover:border-[#FF7900] hover:text-[#FF7900] text-sm font-semibold px-5 py-2.5 rounded-full transition-colors duration-300"
          >
            <Printer className="w-4 h-4" /> {q.print}
          </button>
        </div>
        <div ref={qrRef} className="hidden">
          <QRCodeCanvas value={url} size={560} fgColor="#000000" bgColor="#FFFFFF" />
        </div>
        <canvas ref={canvasRef} width={W} height={H} data-testid="qr-card-canvas" className="w-[220px] rounded-xl border border-white/10 shrink-0 shadow-2xl" />
      </div>
    </div>
  );
};
